module.exports = __webpack_public_path__ + "img/file.56966248.svg";